import Vue from 'vue';
import dayjs from 'dayjs';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
import { LOAD_SUBSCRIPTION } from "src/store/types";
import VueRouter from 'vue-router';
import FormatUtils from 'src/utils/formatters';
import kapiche_mark_inverse from 'assets/img/dashboards/kapiche_mark_inverse.svg';
const { NavigationFailureType } = VueRouter;
export default Vue.extend({
    props: {
        isCollapsed: { type: Boolean, default: false },
    },
    data() {
        return {
            canCollapse: false,
            isCollapseText: false,
            isExpandedText: false,
            dropdownVisible: false,
            kapiche_mark_inverse,
        };
    },
    computed: {
        ...mapGetters([
            'availableSites', 'currentSite', 'currentRoute', 'currentModel', 'isAdmin',
            'currentUser', 'loggedIn', 'dataUnits', 'isTrialing', 'plan',
            'subscribedUntil', 'currentProject', 'currentAnalysis', 'featureFlags', 'hasDate',
        ]),
        isExpanded() {
            return !this.isCollapsed;
        },
        displayAnalysisMenu() {
            return this.$route.fullPath.indexOf('/analysis/') !== -1 && this.currentAnalysis;
        },
        displayProjectMenu() {
            return this.$route.fullPath.indexOf('/projects/') !== -1 &&
                this.$route.fullPath.indexOf('/projects/create') < 0 &&
                this.currentProject &&
                !this.currentUser?.viewer;
        },
        displaySiteMenu() {
            return !this.currentUser?.viewer;
        },
        showDataUnits() {
            return ![Infinity, null].includes(this.dataUnits);
        },
        showSiteTools() {
            return !this.currentUser?.viewer;
        },
        isATrialSite() {
            return this.isTrialing;
        },
        trialDaysRemaining() {
            if (!this.subscribedUntil) {
                return null;
            }
            return dayjs.utc(this.subscribedUntil).diff(dayjs(), 'days');
        },
        linkParams() {
            return {
                site: this.$route.params.site,
                projectId: this.$route.params.projectId,
                analysisId: this.$route.params.analysisId,
                dashboardId: this.currentAnalysis?.dashboards?.[0]?.id,
            };
        },
        selectedSite() {
            return this.$route.params.site;
        },
        nSites() {
            return this.availableSites?.length || 0;
        },
        expandDebounce() {
            return debounce(() => {
                this.toggleCollapse(false);
            }, 100);
        },
        collapseDebounce() {
            return debounce(() => {
                this.toggleCollapse(true);
            }, 100);
        }
    },
    beforeMount() {
        this.$store.dispatch({ type: LOAD_SUBSCRIPTION });
    },
    methods: {
        formatDataUnits: FormatUtils.formatDataUnits,
        /**
         * Change the site to the new site.
         *
         * We're also using this dropdown to switch back to the Projects
         * list page *in the same site*. That means that we want to be able
         * to click the current (active) site in the dropdown and return to
         * the Projects list page for the current site. If this happens,
         * it will *not* throw a NavigationDuplicated error because the route
         * will be different; but, if you're already on the Projects list
         * page then NavigationDuplicated will be thrown. Thus, to deal with
         * that situation we simply catch and absorb the error.
         *
         * @param {string} site
         * @returns {Promise<void>}
         */
        async changeSite(site) {
            try {
                await this.$router.push({ name: 'home', params: { site } });
            }
            catch (e) {
                this.$nprogress.set(1.0);
                if (![NavigationFailureType.duplicated, NavigationFailureType.redirected].includes(e.type)) {
                    throw e;
                }
            }
        },
        toggleCollapse(value) {
            // Specifically used to redraw sentiment Bar in SentimentSummary
            window.dispatchEvent(new Event('resize'));
            if (this.canCollapse) {
                this.$emit('toggle-collapse', value);
            }
        },
        collapseSideBar() {
            if (this.canCollapse && !this.dropdownVisible) {
                this.collapseDebounce();
            }
        },
        expandSideBar() {
            if (this.isCollapsed && this.canCollapse) {
                this.expandDebounce();
            }
        },
        toggleCanCollapse() {
            this.canCollapse = !this.canCollapse;
            let msg = this.canCollapse ? 'SideBar Collapsed' : 'SideBar Expanded';
            this.$analytics.track.sideBarCollapse(msg);
            if (this.canCollapse) {
                this.collapseSideBar();
            }
        }
    }
});
